import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '../../AbstractElements'
import { dynamicImage } from '../../Utils'

export default function LogoIconWrapper() {
    return (
        <div className="logo-icon-wrapper bg-white" style={{padding:'17px 13px 17px 0px'}}>
            <Link to={`/admin`}>
                <Image className="img-fluid" src={dynamicImage(`logo/logo-icon.png`)} alt="" />
            </Link>
        </div>
    )
}
